import React from 'react';

const CreditsInfo = () => {
  return <h1>CreditsInfo Page</h1>;
};

export default CreditsInfo;
